import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker registration
if (process.env.NODE_ENV === "development") {
  // In development, DISABLE service worker to prevent disruptions during testing
  // The service worker can cause unexpected page refreshes during active use
  serviceWorkerRegistration.unregister();
  console.log("[SW] Service worker disabled in development mode");
} else {
  // In production, register service worker for offline support
  serviceWorkerRegistration.register();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
